import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoIsForSection() {
  const ref = useScrollReveal();
  return <section ref={ref} className="w-full section-padding" style={{
    backgroundColor: '#f0ebe2'
  }} aria-label="Who this is for and not for" data-id="element-305">
      <div className="max-w-4xl mx-auto" data-id="element-306">
        {/* Label */}
        <div className="scroll-reveal text-center mb-10" data-id="element-307">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase px-3 py-1.5 rounded-full" style={{
          color: '#c9a96e',
          backgroundColor: 'rgba(201,169,110,0.12)',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-308">
            Is This Right For You?
          </span>
        </div>

        {/* Heading */}
        <div className="scroll-reveal scroll-reveal-delay-1 text-center mb-4" data-id="element-309">
          <h2 className="text-3xl md:text-4xl font-bold leading-tight" style={{
          fontFamily: "'Playfair Display', serif",
          color: '#1a2744'
        }} data-id="element-310">
            This Was Made For You If…
          </h2>
        </div>

        <div className="scroll-reveal scroll-reveal-delay-2 gold-divider mb-12" data-id="element-311" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-312">
          {/* Who it's for */}
          <div className="scroll-reveal scroll-reveal-delay-2 rounded-2xl p-6 md:p-8" style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(201,169,110,0.2)',
          boxShadow: '0 4px 20px rgba(26,39,68,0.07)'
        }} data-id="element-313">
            <h3 className="text-xl font-bold mb-6 flex items-center gap-2" style={{
            fontFamily: "'Playfair Display', serif",
            color: '#1a2744'
          }} data-id="element-314">
              <span className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: 'rgba(201,169,110,0.15)'
            }} data-id="element-315">
                <CheckIcon className="w-4 h-4" style={{
                color: '#c9a96e'
              }} aria-hidden="true" data-id="element-316" />
              </span>
              This IS For You
            </h3>
            <ul className="space-y-4" role="list" data-id="element-317">
              <li className="flex gap-3 items-start" data-id="element-318">
                <CheckIcon className="w-4 h-4 flex-shrink-0 mt-1" style={{
                color: '#c9a96e'
              }} aria-hidden="true" data-id="element-319" />
                <p className="text-sm leading-relaxed" style={{
                color: '#4a4540',
                fontFamily: "'Inter', sans-serif"
              }} data-id="element-320">
                  Parents of toddlers (18 months to 4 years) who refuse to stay
                  in their own bed.
                </p>
              </li>
              <li className="flex gap-3 items-start" data-id="element-321">
                <CheckIcon className="w-4 h-4 flex-shrink-0 mt-1" style={{
                color: '#c9a96e'
              }} aria-hidden="true" data-id="element-322" />
                <p className="text-sm leading-relaxed" style={{
                color: '#4a4540',
                fontFamily: "'Inter', sans-serif"
              }} data-id="element-323">
                  Working moms and dads who are suffering from chronic sleep
                  deprivation.
                </p>
              </li>
              <li className="flex gap-3 items-start" data-id="element-324">
                <CheckIcon className="w-4 h-4 flex-shrink-0 mt-1" style={{
                color: '#c9a96e'
              }} aria-hidden="true" data-id="element-325" />
                <p className="text-sm leading-relaxed" style={{
                color: '#4a4540',
                fontFamily: "'Inter', sans-serif"
              }} data-id="element-326">
                  Families who want a solution that doesn't involve the trauma
                  of "Cry It Out."
                </p>
              </li>
              <li className="flex gap-3 items-start" data-id="element-327">
                <CheckIcon className="w-4 h-4 flex-shrink-0 mt-1" style={{
                color: '#c9a96e'
              }} aria-hidden="true" data-id="element-328" />
                <p className="text-sm leading-relaxed" style={{
                color: '#4a4540',
                fontFamily: "'Inter', sans-serif"
              }} data-id="element-329">
                  Parents dealing with the 2 AM "bed invasion" every single
                  night.
                </p>
              </li>
            </ul>
          </div>

          {/* Who it's NOT for */}
          <div className="scroll-reveal scroll-reveal-delay-3 rounded-2xl p-6 md:p-8" style={{
          backgroundColor: '#faf7f2',
          border: '1px solid rgba(107,101,96,0.15)'
        }} data-id="element-330">
            <h3 className="text-xl font-bold mb-6 flex items-center gap-2" style={{
            fontFamily: "'Playfair Display', serif",
            color: '#6b6560'
          }} data-id="element-331">
              <span className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: 'rgba(107,101,96,0.1)'
            }} data-id="element-332">
                <XIcon className="w-4 h-4" style={{
                color: '#6b6560'
              }} aria-hidden="true" data-id="element-333" />
              </span>
              This Is NOT For You
            </h3>
            <ul className="space-y-4" role="list" data-id="element-334">
              <li className="flex gap-3 items-start" data-id="element-335">
                <XIcon className="w-4 h-4 flex-shrink-0 mt-1" style={{
                color: '#a09890'
              }} aria-hidden="true" data-id="element-336" />
                <p className="text-sm leading-relaxed" style={{
                color: '#6b6560',
                fontFamily: "'Inter', sans-serif"
              }} data-id="element-337">
                  Parents of newborns (under 12 months) — this protocol is
                  designed for toddler biology.
                </p>
              </li>
              <li className="flex gap-3 items-start" data-id="element-338">
                <XIcon className="w-4 h-4 flex-shrink-0 mt-1" style={{
                color: '#a09890'
              }} aria-hidden="true" data-id="element-339" />
                <p className="text-sm leading-relaxed" style={{
                color: '#6b6560',
                fontFamily: "'Inter', sans-serif"
              }} data-id="element-340">
                  Those looking for a "magic pill" that requires zero
                  consistency.
                </p>
              </li>
              <li className="flex gap-3 items-start" data-id="element-341">
                <XIcon className="w-4 h-4 flex-shrink-0 mt-1" style={{
                color: '#a09890'
              }} aria-hidden="true" data-id="element-342" />
                <p className="text-sm leading-relaxed" style={{
                color: '#6b6560',
                fontFamily: "'Inter', sans-serif"
              }} data-id="element-343">
                  People unwilling to follow a strict 3-day environmental
                  protocol.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}